import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  ls,
  f,
  useMsgz,
  BoxC,
  BtnC,
  BtnCttC,
  CbxC,
  IptC,
  LblC,
  GridC,
  TextC,
  _cv_10___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';

import * as ihd from 'src/ihd';
import * as ica from 'src/ica';
import * as icv from 'src/icv';

import * as icvI19___Mz from './icvI19___Mz';

let $_20z = icvI19___Mz.ilz_20z();

export const B = (pz: _ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _b = await _hm.ectSrlAsync([
            async () => { // 必須項目の入力
              let _b = true;
              if (
                !_hm.f($_20z._20rz._pfx) || // クライアント名
                !_hm.f($_20z.i19rz.i19ra1110s) || // スタッフ用ドメイン
                !_hm.f($_20z.i19rz.i19ra1120s) || // スタッフ用ログインID
                !_hm.f($_20z.i19rz.i19ra1130s) || // スタッフ用パスワード
                !_hm.f($_20z.i19rz.i19ra1210s) || // 団体用ドメイン
                !($_20z.i19rz.i19ra1220i > 0) // ログイン方式
              ) {
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => { // スタッフ用ドメインの重複
              let _b = true;
//hf.l(`icvI10___Ci 63: ${$_20z.i19rz.i19ra1110s}, ${$_20z.i19rz._fst}`)
              const _dz = await icvI19___Mz.loadI19rDzAsync({
                dmnName: $_20z.i19rz.i19ra1110s,
                cdn: `_fst <> ${$_20z.i19rz._fst ?? -1}`,
              });
              if (_hm.f(_dz.i19rz)) {
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: 'スタッフ用ドメインが重複しているため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => { // 団体用ドメインの重複
              let _b = true;
              const _dz = await icvI19___Mz.loadI19rDzAsync({
                dmnName: $_20z.i19rz.i19ra1210s,
                cdn: `_fst <> ${$_20z.i19rz._fst ?? -1}`,
              });
              if (_hm.f(_dz.i19rz)) {
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '団体用ドメインが重複しているため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => { // ログインIDの重複
              let _b = true;
              const _ls = await _cv_10___Mz.load_10rLsAsync({
                _dmn: $_20z.i19rz._dmn,
                _10ra2100s: $_20z.i19rz.i19ra1120s,
                cdn: `_icn <> '${icv.icnAmn}'`,
              });
              if (_ls.length > 0) {
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: 'ログインIDが重複しているため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ]);
          if (_b) {
            const __20z = await icvI19___Mz.save_20rDzAsync({
              ... pz,
              _20z: $_20z,
            });
            return {
              _20r_key:__20z._20rz._key,
            };
          }
        }
      }
    })
  );
};

export const D = (pz: _ht.viewDtlCz) => {

  const _udtThis = ls.udtThis();

  React.useEffect( () => {
    _cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _udtThis,
      bfrAsync: () => [
      ],
      crtAsync: () => [
        icvI19___Mz.crt_20z()
        .then((_dz: _ht.dz) => {
          $_20z = _dz;
        })
      ],
      udtAsync: () => [
        icvI19___Mz.load_20rDzAsync({
          _20r_key: pz.sPz.crt._20r_key
        })
        .then(async (_dz: _ht.dz) => {
          //_hm.l(`icvI19___Ci 154a: ${_hm.s(_dz._31rs)}`);
          await _hm.ectSrlAsync(_dz._31rs?.map((__31rz: _ht.dz) => async () => {
            //_hm.l(`icvI19___Ci 154b: ${_hm.s(__31rz)}`);
            const { data: _tkn } = await _cmFTH.getTknAsync({
              _dmn: __31rz._dmn,
              _31r_fst: __31rz._fst,
              cgy: 'r',
            });
            if (_tkn) {
              //_hm.l(`icvI19___Ci 154c: ${_tkn}`);
              if (!__31rz.crlz) __31rz.crlz = {};
              __31rz.crlz.tkn = _tkn;
            }
          }));
          $_20z = _dz;
        })
      ]
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._20r_key,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs = [] as _ht.ls;
  _hdrs.push({
    cellCs: [
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: 'ID',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: '施設',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: '施設URL',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
/*
      {
        boxStlz: a('f/0.5'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: '開始時刻',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        boxStlz: a('f/0.5'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: '終了時刻',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
*/
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: 'メールアドレス',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: 'パスワード',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblOrnz',
            textz: {
              pfx: 'トークン',
              stlz: a(`tc/${pz.cz.ccd}7`),
            }
          })
        ]
      },
      {
        boxStlz: a('dw/btn f/n'),
        oClds: [
        ]
      },
    ],
  });

  const _bdys = [] as _ht.ls;
  ihd.nd($_20z._31rs)
  .map((__31rz: _ht.dz) => {
    const _i191z = _hm.get1(__31rz.cldz?.i191s, ihd.i('i191'));
    if (!_hm.f(__31rz.cldz?.i191s)) __31rz.cldz?.i191s.push(_i191z);
    //hf.l(`icvI19___Ci 247: ${_hm.s(_i191z)}`)
    _bdys.push({
      cellCs: [
        {
          boxStlz: a('f/0.25'),
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: __31rz._icn,
                onChg: (_s: _ht.s) => {
                  __31rz._icn = _s;
                }
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: __31rz._pfx,
                onChg: (_s: _ht.s) => {
                  __31rz._pfx = _s;
                }
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: _i191z?.i191a1100s,
                onChg: (_s: _ht.s) => {
                  _i191z.i191a1100s = _s;
                }
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: _i191z?.i191a4110s,
                onChg: (_s: _ht.s) => {
                  _i191z.i191a4110s = _s;
                }
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                bScr: true,
                iptType: 'text',
                vle: _i191z?.i191a4120s,
                onChg: (_s: _ht.s) => {
                  _i191z.i191a4120s = _s;
                }
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: false,
                iptType: 'text',
                vle: __31rz.crlz.tkn,
              }
            })
          ]
        },
        {
          boxStlz: a('dw/btn f/n'),
          oClds: [
            _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              abtType: 'dltIconz',
              //boxStlz: a(`sc/${pz.cz.ccd}5`),
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  __31rz._dlt = 1;
                  _udtThis();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });
  if ( _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              abtType: 'addOrnz',
              boxStlz: a(`sc/${pz.cz.ccd}5`),
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  //  _hm.l(`IcvI19b 135: here`)
                  const _dz = ihd.i(`_31r`);
                  _hm.udtDz(_dz, {
                  })
                  $_20z._31rs.push(_dz);
                  _udtThis();
                },
              },
            })
          ]
        },
      ],
    });
  }

  //hf.l(`Icvi19b 163: ${_hm.s(_hm.j($_20z.i19rz.i19ra3100j))}`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [
/*
        cr.c(TextC.N, {
          key: -10,
          abtType: 'rmkRqrCmnz'
        }),

        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
        }),
*/
        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
          boxStlz: a('mb/2'),
          lineCs: [
            {
              boxStlz: a(`dw/60 f/n mb/1 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: 'クライアントID：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: '1',
//                              ls: spl.grps,
                              vle: $_20z._20rz._icn,
                              onChg: (_s: _ht.s) => {
                                $_20z._20rz._icn = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`dw/60 f/n mb/2 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: 'クライアント名：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: 'クライアント 1',
//                              ls: spl.grps,
                              vle: $_20z._20rz._pfx,
                              onChg: (_s: _ht.s) => {
                                $_20z._20rz._pfx = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  boxStlz: a(`dw/20 f/n`),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblOrnz',
                      textz: {
                        pfx: '（スタッフ用）',
                        stlz: a(`tc/${pz.cz.ccd}7`),
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: 'ドメイン：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_20z.i19rz.i19ra1110s,
                              onChg: (_s: _ht.s) => {
                                $_20z.i19rz.i19ra1110s = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: 'ログインID：', // 施設共通
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: 'staff-1',
//                              ls: spl.grps,
                              vle: $_20z.i19rz.i19ra1120s,
                              onChg: (_s: _ht.s) => {
                                $_20z.i19rz.i19ra1120s = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: 'パスワード：', // 施設共通
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              bScr: true,
                              iptType: 'text',
//                              vle: 'password',
//                              ls: spl.grps,
                              vle: $_20z.i19rz.i19ra1130s,
                              onChg: (_s: _ht.s) => {
                                $_20z.i19rz.i19ra1130s = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  boxStlz: a(`dw/20 f/n`),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'lblOrnz',
                      textz: {
                        pfx: '（団体用）',
                        stlz: a(`tc/${pz.cz.ccd}7`),
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: 'ドメイン：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: 'client-dantai',
//                              ls: spl.grps,
                              vle: $_20z.i19rz.i19ra1210s,
                              onChg: (_s: _ht.s) => {
                                $_20z.i19rz.i19ra1210s = _s;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/16`),
                        textz: {
                          pfx: 'ログイン方式：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
//                              vle: 'メールアドレス',
//                              ls: spl.grps,
                              ls: ihd.f(`i19ra1220i`).ls,
                              vle: $_20z.i19rz.i19ra1220i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra1220i = _dz.key;
                              }
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: 'エントリー間隔：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f(`i19ra4100i`).ls,
                              vle: $_20z.i19rz.i19ra4100i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra4100i = _dz.key;
                                _udtThis();
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    $_20z.i19rz.i19ra4100i > 1 ?
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: 'エントリー基準月：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f(`i19ra4200i`).ls,
                              vle: $_20z.i19rz.i19ra4200i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra4200i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    })
                    : undefined,
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: 'メール送信機能：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
//                              vle: 'する',
//                              ls: spl.grps,
                              ls: ihd.f(`i19ra2110i`).ls,
                              vle: $_20z.i19rz.i19ra2110i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra2110i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '備品・駐車場機能：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f(`i19ra2210i`).ls,
                              vle: $_20z.i19rz.i19ra2210i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra2210i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '外部連携機能：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
//                              vle: 'する',
//                              ls: spl.grps,
                              ls: ihd.f(`i19ra2410i`).ls,
                              vle: $_20z.i19rz.i19ra2410i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra2410i = _dz.key;
                                _udtThis();
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    $_20z.i19rz.i19ra2410i == 1?
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '外部連携公開区分：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f(`i19ra2420i`).ls,
                              vle: $_20z.i19rz.i19ra2420i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra2420i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    })
                    : undefined,
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '電子決済機能：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
//                              vle: 'する',
//                              ls: spl.grps,
                              ls: ihd.f(`i19ra2310i`).ls,
                              vle: $_20z.i19rz.i19ra2310i,
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra2310i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '決済用公開鍵：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: '1234567890abcdefghijklmnopqrstuvwxyz',
//                              ls: spl.grps,
//                              vle: $_20z.i19rz.i19ra2320s,
                              vle: $_20z._801z?._801a2100s,
                              onChg: (_s: _ht.s) => {
                                $_20z._801z._801a2100s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      lblCz: {
                        boxStlz: a(`dw/20`),
                        textz: {
                          pfx: '決済用秘密鍵：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
//                              vle: '1234567890abcdefghijklmnopqrstuvwxyz',
//                              ls: spl.grps,
//                              vle: $_20z.i19rz.i19ra2330s,
                              vle: $_20z._802z?._802a2100s,
                              onChg: (_s: _ht.s) => {
                                $_20z._802z._802a2100s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },


              ]
            },
            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      boxStlz: a(`fd/rss`),
                      lblCz: {
                        boxStlz: a(`dw/20 mt/0.5`),
                        textz: {
                          pfx: '非表示の団体項目：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(CbxC.MM, {
                            key: -10,
                            boxStlz: a('dw/f pt/0.5'),
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              ls: ihd.f(`i19ra3100j`).ls,
                              vlez: _hm.f($_20z.i19rz.i19ra3100j) ? _hm.j($_20z.i19rz.i19ra3100j) : {},
                              onChg: (_dz: _ht.dz) => {
                                //hf.l(`IcvI19b 606: ${_hm.s(_dz)}`);
                                $_20z.i19rz.i19ra3100j = _hm.s(_dz);
                              }
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

            {
              boxStlz: a(`f/n mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlOrnz',
                      boxStlz: a(`fd/rss`),
                      lblCz: {
                        boxStlz: a(`dw/20 mt/0.5`),
                        textz: {
                          pfx: '必須の団体項目：',
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(CbxC.MM, {
                            key: -10,
                            boxStlz: a('dw/88 pt/0.5'),
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              ls: ihd.f(`i19ra3200j`).ls,
                              vlez: _hm.f($_20z.i19rz.i19ra3200j) ? _hm.j($_20z.i19rz.i19ra3200j) : {},
                              onChg: (_dz: _ht.dz) => {
                                $_20z.i19rz.i19ra3200j = _hm.s(_dz);
                              }
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

          ]
        }),

        cr.c(GridC.N, {
          key: -60,
          abtType: 'hdrOrnz',
          boxStlz: a('dwx/120 mh/a'),
          lineCs: _hdrs
        }),

        cr.c(GridC.N, {
          key: -70,
          abtType: 'lineOrnz',
          boxStlz: a('dwx/120 mh/a'),
          lineCs: _bdys
        })

      ]
    })
  );
};

